export default __webpack_public_path__ + "media/images/sofa-image-023c88ef9f21c6b6c9c731937bd2055e.jpg";